import { AppSettingsClient } from '@amzn/event-engine-js-utils';

// All of the feature flags are typed as "string", but the only valid
// values are "true" or "false" (notice the double string)
export interface IFeatureFlag {
    [key: string]: string;
}

export interface ISettings {
    eventsApiEndpoint: string;
    contentApiEndpoint: string;
    authProxyEndpoint: string;
    unauthenticatedCognitoIdentityPoolId: string;
    kinesisFirehoseStreamLocale: string;
    region: string;
    staticContentEndpoint: string;
    lambdaStaticAssetCopierInvalidator?: string;
    featureFlags: IFeatureFlag;
    amplify: any;
}

export const AppSettings = async (): Promise<ISettings> => {
    const appSettingsClient = AppSettingsClient.getInstance(
        process.env.NODE_ENV === 'production'
    );

    try {
        const settings = await appSettingsClient.get<ISettings>();

        AppSettingsClient.validate<ISettings>(settings, [
            'unauthenticatedCognitoIdentityPoolId',
            'region',
            'staticContentEndpoint',
        ]);

        return settings;
    } catch (err) {
        return Promise.reject(new Error('unable to load client settings'));
    }
};

export default AppSettings;
